import { render, staticRenderFns } from "./CallDetails.vue?vue&type=template&id=3493807a&scoped=true&lang=pug"
import script from "./CallDetails.vue?vue&type=script&lang=js"
export * from "./CallDetails.vue?vue&type=script&lang=js"
import style0 from "./CallDetails.vue?vue&type=style&index=0&id=3493807a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3493807a",
  null
  
)

export default component.exports